<template>
  <div class="i-panel-item ui-layout-east relative">
    <div class="flex flex-col absolute inset-0">
      <div class="flex-auto overflow-y-scroll text-sm-fix">
        <slot />
      </div>
      <div class="flex-none i-panel-footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.i-panel-footer {
  height: 50px;
  line-height: 49px;
  background: #f2f2f2;
  border-top: 1px solid #cfcfcf;
}
</style>
